import React from "react";

import { Grid, Bar } from "./Styles";

const QuestionDetailChoices = ({ question, surveys }) => {
    const [data, setData] = React.useState([]);
    const [count, setCount] = React.useState(0);

    React.useEffect(() => {
        const counter = {};
        let _count = 0;
        
        surveys.forEach((survey) => {

            if (survey[question.value]) {
                if (Array.isArray(survey[question.value])){
                    survey[question.value].forEach((answer)=>{
                        _count++;
                        if (counter[`${answer}`] === undefined) {
                            counter[`${answer}`] = 0;
                        }
        
                        counter[`${answer}`]++;
                    });
                }

                if (typeof survey[question.value] === "string"){
                    _count++;
                    if (counter[`${survey[question.value]}`] === undefined) {
                        counter[`${survey[question.value]}`] = 0;
                    }

                    counter[`${survey[question.value]}`]++;
                }
                

            }
        });

        const _data = [];

        for (let index in counter) {
            _data.push({ count: counter[index], label: index })
        }

        setData(_data);
        setCount(_count);
    }, [question, surveys]);

    return (
        <React.Fragment>
            <div className="pos-relative">
                <Grid>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((value, index) => {
                        return <span key={value}></span>
                    })}
                </Grid>
                {data.map((ans, index) => {
                    
                    const percent = ans.count * 100 / count;
                    return (
                        <Bar key={index}>
                            <label
                                style={{ width: `${percent}%` }}
                                title={`${percent.toFixed(0)}%, ${ans.count} Respuestas`}>
                                {ans.label} ({percent.toFixed(0)}%)
                            </label>

                        </Bar>
                    )
                })}

            </div>
        </React.Fragment>
    )
}

export default QuestionDetailChoices;